<template>
  <div class="d-copy-cals text-dark">
    <div class="d-acc" :class="{'d-acc--open': isAccOpen}">
      <div class="d-acc__header" @click="toggleIsAccOpen">
        <div class="d-acc__header__left">
          <div class="d-toggle-arrow" :class="{'d-toggle-arrow--open': isAccOpen}"></div>
          <h3>{{ title }} ({{ calendarsExclArchived.length }})</h3>
        </div>
      </div>
      <ul class="d-copy-cals__list" v-if="isAccOpen">
        <li class="d-copy-cals__cal" v-for="calendar in calendarsExclArchived" :key="calendar.id">
          <div class="d-copy-cals__cal__left">
            {{ calendar.name }}
          </div>
          <div class="d-copy-cals__cal__right">
            <button class="bttn bttn-simple bttn--small" @click.stop="setEditCal(calendar.id)"><span
              class="icon-pencil"></span></button>
            <button class="bttn bttn-simple bttn--small" @click.stop="archiveCal(calendar.id)"
                    v-if="calType === 'room' || calType === 'merge'">
              {{ $t('vue2.calendars.archive') }}
            </button>
            <button v-else class="bttn bttn-simple bttn--small bttn--warning" @click.stop="setDeleteCal(calendar.id)">
              <span class="icon-bin"></span></button>
          </div>
        </li>
        <li class="archived-cals-toggler" v-if="archivedCalendars.length > 0"
            @click="isArchivedAccOpen = !isArchivedAccOpen">
          <div class="d-toggle-arrow" :class="{'d-toggle-arrow--open': isArchivedAccOpen}"></div>
          <p>
            <span v-if="!isArchivedAccOpen">{{ $t('vue2.calendars.show') }} </span><span
            v-else>{{ $t('vue2.calendars.hide') }}</span> {{ $t('vue2.calendars.archived') }} ({{ archivedCalendars.length }})</p>
        </li>
        <li class="archived-cal"
            v-for="archivedCalendar in archivedCalendars"
            :key="archivedCalendar.id"
            v-if="isArchivedAccOpen">
          {{ archivedCalendar.name }}
          <button v-if="calType === 'room' || calType === 'merge'" class="bttn bttn-simple bttn--small"
                  @click.stop="deArchiveCal(archivedCalendar.id)">{{ $t('vue2.calendars.unarchive') }}
          </button>
        </li>
      </ul>
    </div>
    <DModal v-if="theActiveCalId" @close="theActiveCalId = null" :showClose="false">
      <template slot="insertComponent">
        <div class="d-modal__header">
          <h2>{{ $t('vue2.editCalendarEditName.edit_name') }}</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeUpdateCalName"><span
            class="icon-cross2"></span></div>
        </div>
        <div class="d-modal__body">
          <div class="input-group">
            <label>{{ $t('vue2.calendars.write_name') }}</label>
            <input type="text" v-model.lazy="theUpdateCalName" ref="edit_name_input">
          </div>
          <div class="d-modal__buttons">
            <button class="marg-5-right" @click="closeUpdateCalName">{{ $t('vue2.common.cancel') }}</button>
            <button class="submit-button" @click="updateCalName">{{ $t('vue2.common.update') }}</button>
          </div>
        </div>
      </template>
    </DModal>
    <DModal v-if="theDeleteCalId" @close="theDeleteCalId = null" :showClose="false">
      <template slot="insertComponent">
        <div class="d-modal__header">
          <h2>{{ $t('vue2.calendars.do_you_want_to_delete') }} "{{ deleteCalName }}"?</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeDeleteCalModal"><span
            class="icon-cross2"></span></div>
        </div>
        <div class="d-modal__body">
          <div class="input-group">
            <h4>{{ $t('vue2.editCalendarDelete.write') }} "{{ deleteCalName }}"
              {{ $t('vue2.editCalendarDelete.if_you_want_to_delete') }}</h4>
            <input type="text" v-model="theDeleteCalName" ref="delete_name_input">
          </div>
          <h4 class="text-danger marg-20-top">{{ $t('vue2.editCalendarDelete.all_data_will_be_deleted') }}</h4>
          <div class="d-modal__buttons">
            <button class="marg-5-right" @click="closeDeleteCalModal">{{ $t('vue2.common.cancel') }}</button>
            <button class="submit-button submit-button--disabled" v-if="!isDeleteCalValidated">
              {{ $t('vue2.common.delete') }}
            </button>
            <button class="submit-button submit-button--danger" @click="deleteCal" v-else>{{
                $t('vue2.common.delete')
              }}
            </button>
          </div>
        </div>
      </template>
    </DModal>
  </div>
</template>

<script>
import DModal from '../common/DModal'

export default {
  components: {DModal},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    calType: {
      type: String,
      default: 'klass'
    },
    calendars: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isAccOpen: false,
      isArchivedAccOpen: false,
      theActiveCalId: null,
      theUpdateCalName: '',
      theDeleteCalId: null,
      theDeleteCalName: ''
    }
  },
  computed: {
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    calendarsExclArchived () {
      return this.calendars.filter(calendar => !calendar.archived_at)
    },
    archivedCalendars () {
      return this.calendars.filter(calendar => calendar.archived_at)
    },
    deleteCalName () {
      return this.theDeleteCalId ? this.allCalendarsInHash[this.theDeleteCalId].name : ''
    },
    isDeleteCalValidated () {
      return this.theDeleteCalName.length > 0 && (this.theDeleteCalName === this.deleteCalName)
    },
    title () {
      switch (this.calType) {
        case 'klass':
          return this.$t('vue2.common.classes')
        case 'user':
          return this.$t('vue2.common.users')
        case 'room':
          return this.$t('vue2.common.rooms')
        case 'merge':
          return this.$t('vue2.common.merge_calendars')
        case 'other':
          return this.$t('vue2.common.other_calendars')
      }
    }
  },
  methods: {
    getIsInselectedCalIds (calId) {
      return this.selectedCalIds.indexOf(calId) > -1
    },
    toogleCal (calId) {
      let idx = this.selectedCalIds.indexOf(calId)
      if (idx < 0) {
        this.selectedCalIds.push(calId)
      } else {
        this.selectedCalIds.splice(idx, 1)
      }
    },
    toggleAllKlasses () {
      if (this.selectedCalIds.length > 0) {
        this.selectedCalIds = []
      } else {
        this.selectedCalIds = []
        this.calendars.forEach(calendar => this.selectedCalIds.push(calendar.id))
      }
    },
    toggleIsAccOpen () {
      if (!this.isAccOpen) {
        this.isAccOpen = true
      } else {
        this.isAccOpen = false
        this.selectedCalIds = []
      }
    },
    archiveCal (calId) {
      let calObj = {
        calendarId: calId,
        changes: {name: this.allCalendarsInHash[calId].name, archived: true}
      }
      this.$store.dispatch('updateCalendar', calObj)
    },
    deArchiveCal (calId) {
      let calObj = {
        calendarId: calId,
        changes: {name: this.allCalendarsInHash[calId].name, archived: false}
      }
      this.$store.dispatch('updateCalendar', calObj)
    },
    setEditCal (calId) {
      this.theUpdateCalName = this.allCalendarsInHash[calId].name
      this.theActiveCalId = calId
      setTimeout(_ => {
        this.$refs.edit_name_input.focus()
      }, 500)
    },
    closeUpdateCalName () {
      this.theUpdateCalName = ''
      this.theActiveCalId = null
    },
    updateCalName () {
      let archived = this.allCalendarsInHash[this.theActiveCalId].archived_at
      let calObj = {
        calendarId: this.theActiveCalId,
        changes: {name: this.theUpdateCalName, archived: archived}
      }
      this.$store.dispatch('updateCalendar', calObj)
      this.closeUpdateCalName()
    },
    setDeleteCal (calId) {
      this.theDeleteCalId = calId
      setTimeout(_ => {
        this.$refs.delete_name_input.focus()
      }, 500)
    },
    closeDeleteCalModal () {
      this.theDeleteCalId = null
      this.theDeleteCalName = ''
    },
    deleteCal () {
      this.$store.dispatch('deleteCalendar', this.theDeleteCalId)
      this.closeDeleteCalModal()
    }
  },
  mounted () {
    if (this.isOpen) {
      this.isAccOpen = true
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-acc {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.d-acc ul {
  border: 1px solid #d8d8d8;
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin: 0;
}

.d-acc ul li {
  user-select: none;
}

.d-acc__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  border: 1px solid #d8d8d8;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.25s;
}

.d-acc:not(.d-acc--open) .d-acc__header:hover {
  border-color: var(--blue);
}

.d-acc--open .d-acc__header {
  border-radius: 4px 4px 0 0;
}

.d-acc__header__left {
  display: flex;
  align-items: center;
}

.d-copy-cals__list li:nth-child(odd) {
  background: #f8fafb;
}

.d-copy-cals__cal {
  padding: 0.25rem 2rem;
  display: flex;
  align-items: center;
  border-top: 1px solid transparent;
  justify-content: space-between;
}

.d-copy-cals__list li:hover {
  background: aliceblue;
}

.d-copy-cals__list li.d-copy-cals__cal.d-copy-cals__cal--selected {
  border-top: 1px solid #fff;
  background-color: rgba(77, 138, 207, .3);
}

.d-copy-cals__list__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d-copy-cals__list li.d-copy-cals__cal:hover {
  color: var(--blue);
}

.d-copy-cals__list__header__right > p {
  margin-right: 1rem;
}

.d-toggle-arrow {
  width: 7px;
  height: 7px;
  border: 2px solid var(--dark-blue);
  border-width: 2px 2px 0 0;
  transform: rotate(45deg);
  margin-right: 1rem;
  transition: transform 0.25s;
}

.d-toggle-arrow.d-toggle-arrow--open {
  transform: rotate(135deg);
}

.archived-cals-toggler {
  display: flex;
  align-items: center;
  padding: 1rem 3rem;
  font-weight: bold;
  cursor: pointer;
}

.archived-cals-toggler:hover {
  color: var(--blue);
}

.archived-cal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 2rem;
}

.bttn--small {
  margin-left: 0.5rem;
  font-size: 0.9rem;
}

.bttn.bttn-simple.bttn--warning:hover {
  background: var(--danger) !important;
}

.d-modal__header {
  background: #fff;
  padding: 1rem;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  text-align: center;
  position: relative;
}

.d-modal__header__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
  font-size: 1.2rem;
  opacity: 0.85;
}

.d-modal__body {
  width: 400px;
  padding: 1rem 2rem;
}

.input-group input {
  width: 100%;
  border-radius: 4px;
  cursor: text;
  border: 1px solid #edf2f7;
  -webkit-appearance: none !important;
  background: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  box-sizing: border-box !important;
  transition: background-color .24s, box-shadow .24s;
}

.d-copy-cals__cal__right {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// CalendarsBulkArchiveCalendar.vue?f288ed36